import { createSelector } from 'reselect';

import { getIdMap } from '../helpers/helpers';

// Base selectors (input selectors) - these extract raw state
export const getCustomers = (state) => state.customers.customers;
export const getVendors = (state) => state.vendors.vendors;
export const getProjects = (state) => state.projects.projects;
export const getPhases = (state) => state.costcodes.phases;
export const getUsers = (state) => state.users.users;
export const getEquipment = (state) => state.equipment.equipment;

// Memoized selectors - these transform the state and are globally cached
// Only recompute when their input selectors return new values
export const getCustomerList = createSelector(
  [getCustomers],
  (customers) => Object.values(customers),
);

export const getVendorList = createSelector(
  [getVendors],
  (vendors) => Object.values(vendors),
);

export const getProjectIdMap = createSelector(
  [getProjects],
  (projects) => getIdMap(projects),
);

export const getPhaseIdMap = createSelector(
  [getPhases],
  (phases) => getIdMap(phases),
);

export const getUserIdMap = createSelector(
  [getUsers],
  (users) => getIdMap(users),
);

export const getEquipmentIdMap = createSelector(
  [getEquipment],
  (equipment) => getIdMap(equipment),
);
